// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Yz7Mo{transition:opacity 150ms ease,filter 150ms ease}.Yz7Mo.FgxIk{opacity:.32;filter:blur(4px);pointer-events:none;user-select:none}.Yz7Mo.FgxIk *{user-select:none !important;-webkit-user-select:none !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Yz7Mo`,
	"disabled": `FgxIk`
};
export default ___CSS_LOADER_EXPORT___;
